export default __webpack_public_path__ + "static/media/es-ct.3d8d3583.svg";